// more recent versions should always go at the top

const emulatorVersions : string[] = [
    '0.9.12',
    '0.9.11',
    '0.9.10',
    '0.9.9',
];

export default emulatorVersions;
